require('./helpers/bundle-manifest').register(JSON.parse("{\"l39xu\":\"main.js\",\"4ck1n\":\"main.daab11b3.js\",\"c2pZ3\":\"main.css\"}"));